/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { FormEvent, useEffect, useState } from 'react'
import { ForgotFormBody, LimitError } from './style'
import { resetPassword } from '../../../../../services/AuthService'
import { useAppDispatch } from 'store/store'
import { updateUser } from 'store/reducers/userReducer'
import { FormTypes } from 'types/enums/EFormTypes'
import { setFormTranslatedText } from 'pages/auth/utils/setFormTranslatedText'
import { useTranslation } from 'react-i18next'
import { setForm, setIsLayoutLoading } from 'store/reducers/layoutReducer'
import { EmailInput } from 'shared/components/email-input/EmailInput'
import { Button } from 'shared/components/button/Button'

type ForgotPasswordFormData = {
  email: string
}
type ForgotPasswordFormDataErrors = Partial<
  Record<keyof ForgotPasswordFormData, boolean>
>

export const ForgotPassword: React.FC = () => {
  const dispatch = useAppDispatch()

  const [forgotFormData, setForgotFormData] = useState<ForgotPasswordFormData>({
    email: '',
  })
  const [errors, setErrors] = useState<ForgotPasswordFormDataErrors>({
    email: false,
  })
  const [isDisabled, setIsDisabled] = useState<boolean>(true)
  const [limitError, setLimitError] = useState<boolean>(false)

  const { t } = useTranslation('', {
    keyPrefix: 'pages.forgotPassword',
  })
  setFormTranslatedText('forgotPassword')

  useEffect(() => {
    if (forgotFormData.email && !errors.email && !limitError) {
      setIsDisabled(false)
    } else if (!isDisabled) {
      setIsDisabled(true)
    }
  }, [forgotFormData, limitError])

  const handleEmailChange = (value: string, error?: boolean) => {
    setErrors({ ...errors, email: error })
    setForgotFormData({ ...forgotFormData, email: value })
  }

  const handleSubmit = async (event: FormEvent) => {
    event.preventDefault()
    try {
      dispatch(setIsLayoutLoading(true))
      dispatch(
        updateUser({
          email: forgotFormData.email,
        }),
      )
      await resetPassword(forgotFormData.email.toLowerCase())
      return dispatch(
        setForm({
          formType: FormTypes.RESET_PASSWORD,
          email: forgotFormData.email,
        }),
      )
    } catch (err: unknown) {
      const error = err as Error
      dispatch(setIsLayoutLoading(false))
      if (error.name.startsWith('LimitExceededException')) {
        setLimitError(true)
      }
    }
  }

  return (
    <ForgotFormBody>
      <EmailInput
        value={forgotFormData.email}
        callback={handleEmailChange}
        hasError={errors.email}
        labelText={t('inputs.email.labelText')}
        errorText={t('inputs.email.errorText')}
      />
      <LimitError className={limitError ? 'error' : ''}>
        {t('buttons.submit.errorText')}
      </LimitError>
      <Button
        type="submit"
        disabled={isDisabled}
        className={`button ${isDisabled ? 'disabled' : ''}`}
        text={t('buttons.submit.text')}
        callback={handleSubmit}
      />
      <Button
        type="reset"
        disabled={false}
        text={t('buttons.back.text')}
        callback={() => dispatch(setForm({ formType: FormTypes.LOGIN_FORM }))}
      />
    </ForgotFormBody>
  )
}
